const initialState = {
  user_data: {},
  toggle_header: false,
};

export default initialState;
